export default class ShortCoursesListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
    var shortCoursesVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    
    shortCoursesVm.gradRoleClass = 'grad-5'
    shortCoursesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    shortCoursesVm.$sessionStorage = $sessionStorage

    shortCoursesVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3
        }
      }
    ]

    //VARIABLES
    shortCoursesVm.listShortCourses = []
    shortCoursesVm.viewLoaded = false  
    shortCoursesVm.feedback = 0
    shortCoursesVm.planningFinish = true
    $scope.classPlanning = ''
    let post = {
        workplanId: currentUser.workplanId,
        teacherId: currentUser.teacherId
    }
    shortCoursesVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    //METHODS
    shortCoursesVm.updateView = updateView
    shortCoursesVm.loadData = loadData
    shortCoursesVm.confirmDeleteShortCourse = confirmDeleteShortCourse
    shortCoursesVm.getGeneralsWorkplan = getGeneralsWorkplan
    shortCoursesVm.active = GlobalConfig.generals.active
    shortCoursesVm.notActive = GlobalConfig.generals.notActive
    shortCoursesVm.bitacora = bitacora


    activate()


    function activate(){  
      if(shortCoursesVm.workPlanGeneralList != undefined){
        shortCoursesVm.status = shortCoursesVm.workPlanGeneralList.wokplanTeacherStatus[0]
        shortCoursesVm.stages = shortCoursesVm.workPlanGeneralList.stages
        shortCoursesVm.feedback = shortCoursesVm.status.feedbackReviewed
        shortCoursesVm.workplanTeacherId = shortCoursesVm.status.workplanTeacherId
        isPlanning(shortCoursesVm.status, shortCoursesVm.stages)
      
        if(shortCoursesVm.feedback && !shortCoursesVm.planningFinish){
          getDataFormShortCoursesReject()
        }else{
          getDataFormShortCourses()
        }
      }else{  
        getGeneralsWorkplan(post).then((promise) => {
          if(shortCoursesVm.feedback && !shortCoursesVm.planningFinish){
            getDataFormShortCoursesReject()
          }else{
            getDataFormShortCourses()
          }
        })
      }
      
      updateView()
    }

    function getDataFormShortCourses(){
      WorkPlanSrv.getDataFormShortCourses.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listShortCourses)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(listphd)
        }
      )
    }

    function getDataFormShortCoursesReject(){
      WorkPlanSrv.getDataFormShortCoursesReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listShortCourses)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(listphd)
        }
      )
    }

    function loadData(data){
      shortCoursesVm.listShortCourses = data
    }

    function updateView () {
      shortCoursesVm.viewLoaded = false
      $timeout(() => {
        shortCoursesVm.viewLoaded = true
      }, 1)
    }

    function confirmDeleteShortCourse (course) {   
      let name = course.name
      let workplanTeacherActivityId = course.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.name = name
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                showDeletedSuccessfully(ctrlModalVM.name)
                removeFromCaroussel(course)
                // activate()
                WorkPlanIndicatorSrv.setVariable(true)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(name){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { }) 
    }
    
    function removeFromCaroussel(course){
      for(var i in shortCoursesVm.listShortCourses){
        if(shortCoursesVm.listShortCourses[i].workplanTeacherActivityId === course.workplanTeacherActivityId){
          shortCoursesVm.listShortCourses.splice(i,1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          shortCoursesVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          shortCoursesVm.status = dataReturn.data.wokplanTeacherStatus[0]
          shortCoursesVm.stages = dataReturn.data.stages
          shortCoursesVm.feedback = shortCoursesVm.status.feedbackReviewed
          shortCoursesVm.workplanTeacherId = shortCoursesVm.status.workplanTeacherId
          isPlanning(shortCoursesVm.status, shortCoursesVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      shortCoursesVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          shortCoursesVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == shortCoursesVm.active){        
          shortCoursesVm.planningFinish = true
          if (shortCoursesVm.startDateReview < shortCoursesVm.currentDate || status.reviewedFinish == shortCoursesVm.active){
            shortCoursesVm.planningFinish = true
          }else if (status.reviewedReject == shortCoursesVm.active){
            shortCoursesVm.planningFinish = false
          }
        } else {
            shortCoursesVm.planningFinish = false
        }
      }else{
        shortCoursesVm.planningFinish = true
      }

      $scope.classPlanning = (shortCoursesVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.shortCourses,
        workplanTeacherId: shortCoursesVm.workplanTeacherId
      }
      entries.title = 'Consultoría y asesoría'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}

ShortCoursesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/shortCourses/list/shortCoursesListCtrl.js